module.exports = __webpack_public_path__ + "static/media/38.93bafbfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/38.jpg
// module id = 984
// module chunks = 0